import React, {useState} from 'react';
import Modal from "../../../../components/modal/Modal";
import {CustomTable, CustomTd, CustomTh} from "../rentalAssetViewCss";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import {toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {extendRentalRequest} from "../../../../api/lifecycle/rental/rentalRequestService";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {useDispatch} from "react-redux";
import {changeRefreshRentalRequest} from "../../../../redux/slice/statusSlice";
import {getDate} from "../../../../components/Utils/SimmsUtils";
import {useTranslation} from "react-i18next";

const RentalExtendModal = ({rentalRequest, refresh}) => {
    const initData = {
        extendDate: `${toKSTISOStringEnd(new Date())}`
    };
    const [updateData, setUpdateData] = useState(initData);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const {t} = useTranslation();
    const dispatch = useDispatch();

    const handleOpenModal = (e) => {
        e.stopPropagation();
        setUpdateData({extendDate: rentalRequest.endDate});
        setIsModalOpen(true);
    }
    const handleCloseModal = () => setIsModalOpen(false);

    const handleUpdateExtendDate = async () => {
        if (getDate(rentalRequest.endDate).getTime() === getDate(updateData.extendDate).getTime()) {
            handleActiveError({message: "연장일은 종료일과 같을수 없습니다."});
            return;
        }
        if (window.confirm(t(`confirmChangeEndDate`))) {
            const data = {
                rentalRequestId: rentalRequest.id,
                rentalAssetId: rentalRequest.rentalAssetId,
                extendDate: updateData.extendDate
            };
            await extendRentalRequest(data, () => {
                handleCloseModal();
                handleActiveToast({message: t(`updated`)});
                dispatch(changeRefreshRentalRequest());
                if (refresh) refresh();
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle,statusAlreadyChanged`)
                    });
                if (refresh) refresh();
            });
        }
    }

    return (
        <>
            <button
                className={'text-[13px] px-3 py-0.5 rounded-4 border text-[#333] bg-white hover:bg-gray-50'}
                onClick={handleOpenModal}>
                기간연장
            </button>
            <Modal isOpen={isModalOpen} onClose={() => handleCloseModal()}>
                <h2 className={"font-bold text-[20px]"}>기간 연장</h2>
                <p className={"text-[14px] my-2"}>기간 연장 정보를 입력해주세요.</p>
                <CustomTable>
                    <tbody>
                    <tr>
                        <CustomTh padding={"10px 0 10px 5px"} align={'left'} background={'#f1f6f9'}>
                            기존 대여 종료일
                        </CustomTh>
                        <CustomTd>
                            {rentalRequest.endDate}
                        </CustomTd>
                    </tr>
                    <tr>
                        <CustomTh padding={"10px 0 10px 5px"} align={'left'} background={'#f1f6f9'}>
                            <span className={"text-red-700 text-[15px]"}>*</span>
                            연장할 대여 종료일
                        </CustomTh>
                        <CustomTd>
                            <div>
                                <SimmsDatePicker
                                    onChange={(v) => dateOnChange(setUpdateData, "extendDate", v, true)}
                                    constraint={{
                                        largerThan: dayjs(rentalRequest.endDate),
                                        required: true,
                                        autoClose: true
                                    }}
                                    data={updateData.extendDate} auth/>
                            </div>
                        </CustomTd>
                    </tr>
                    </tbody>
                </CustomTable>
                <div className={'flex justify-end'}>
                    <button className={'btn_save'} onClick={handleUpdateExtendDate}>
                        연장하기
                    </button>
                    <button type="button"
                            className={'border border-[#c4c4c4] px-8 hover:bg-[#f2f2fc]'}
                            onClick={handleCloseModal}>
                        취소
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default RentalExtendModal;